import React, { Component } from 'react';
import * as d3 from 'd3';

import VillagerTable from '../components/VillagerTable';

class VoteSummary extends Component {
  constructor(props){
      super(props);

      this.allVillagers = this.props.villagers;

   }

   componentDidMount() {
   }

  render() {

    return (
      <section ref={this.props.innerRef}  id="vote-summary">
            <h2 className="title">What does "popular" mean?</h2>
            <p className="paragraph">After exploring a few different methods to define villager popularity, we landed on two major categories:</p>
            <p className="paragraph"><span className="highlight medium">Villager Poll Popularity</span>: Based on monthly polls from May 2020 to April 2021 organized by the <a className="link" href="https://animalcrossingportal.com/" target="_blank">Animal Crossing Portal</a> website.</p>
            <p className="paragraph"><span className="highlight medium">Villager Marketplace Demand</span>: If you want a specific villager but don’t want to buy their <a className="inline-tooltip" href="#" aria-label="Nintendo’s officially way of inviting new villagers to your island">Amiibo card</a>,  you can try to encounter them by spending in-game currency.  Websites such as <a className="link" href="https://Nookazon.com" target="_blank">Nookazon</a> connect strangers across the internet to trade this in-game currency, <a className="inline-tooltip" href="#" aria-label="Primary game currency">Bells</a> and <a className="inline-tooltip" href="#" aria-label="Game item that can be purchased with Nookmiles, a secondary game currency or trade with other players. Each NMT gives you a chance to encounter a random villager that you can invite to move in.">Nook Mile Tickets (NMTs)</a>, for their favorite villagers. To get an accurate picture of villager demand, we combined each villager’s Nookazon prices in Bells and NMTs, and used that as our Villager Marketplace Demand.</p>
            <p className="paragraph">Our ultimate formula for Villager Popularity was a combination of:</p>

            <div className="equation-container ranking-formula">
              <div className="equation">
                <span className="middle">Popularity ranking</span>
              </div>
              <div className ="equation">
                <span>=</span>
              </div>
              <div className="equation">
                <span className="top">50%</span>
                <span className="middle">x</span>
                <span className="bottom">Poll popularity</span>
              </div>
              <div className ="equation">
                <span>+</span>
              </div>
              <div className="equation">
                <span className="top">25%</span>
                <span className="middle">x</span>
                <span className="bottom">NMT market price</span>
              </div>
              <div className ="equation">
                <span>+</span>
              </div>
              <div className="equation">
                <span className="top">25%</span>
                <span className="middle">x</span>
                <span className="bottom">Bells market price</span>
              </div>
            </div>


            <p className="paragraph">As an example:</p>
            <VillagerTable villagers={this.allVillagers} startRange={1} endRange={3} id="vote-example-table"/>
      </section>
    )
  }
}

export default VoteSummary;
